module.exports = __webpack_public_path__ + "static/media/94b53667-752a-4de9-88b3-df4f23afc0f3.0e068000.JPG";